import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem',
    width: '90vw',
    margin: '1rem auto 0',   
  },
  title: {
    fontSize: '2rem',
    padding: '1rem 0 0',
  },
  content: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '2rem',
    width: '100%',
  },
  
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '1rem',
    padding: '1.5rem',
    width: '100%',
    backgroundColor: Colors.lightGray,
    borderRadius: '5px',
    '& h3': {
      fontSize: '2.5rem',
    },
  },
  chartRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '3rem',
    padding: '1rem',
    flexWrap: 'wrap',
    width: '100%',
  },
}))

export default styles
